import React from 'react';
import './ProductListHeader.css';

const ProductListHeader = ({
  navigateToAdmin,
  createPath,
  handleCreate,
  handleDeleteSelected,
  handleDownload,
  handleExcelUpload,
  uploading,
  hasSelectedRows,
  showDelete,
  showUpload,
  showDownload,
  title
}) => (
<div className="header-container">
  <div className="header-action-row">
    {/* 🔹 LEFT: Search */}
    <div className="header-search-wrapper">
  <div className="header-title">{title}</div>
  {/* <div className="header-search-container">
    <span className="search-icon">
      <i className="fas fa-search"></i>
    </span>
    <input
      id="search-input"
      type="text"
      placeholder="Search..."
      value={searchQuery}
      onChange={(e) => setSearchQuery(e.target.value)}
      className="header-search-input"
    />
  </div> */}
</div>


    {/* 🔹 RIGHT: Buttons */}
    <div className="header-action-buttons" style={{ display: "flex", gap: "10px", alignItems: "center" }}>
      <div className="header-icon" onClick={navigateToAdmin} title="Go to Admin">
        <i className="fas fa-home"></i>
      </div>

      {showDownload && (
        <button onClick={handleDownload} className="header-download-btn" title="Download Excel">
          <i className="fas fa-file-download"></i>
        </button>
      )}

      {showUpload && (
        <label className="header-upload-label" title="Upload Excel">
          <input
            type="file"
            accept=".xlsx, .xls"
            onChange={handleExcelUpload}
            className="header-upload-input"
            disabled={uploading}
          />
          {uploading ? (
            <i className="fas fa-spinner fa-spin"></i>
          ) : (
            <i className="fas fa-file-upload"></i>
          )}
        </label>
      )}

      {createPath && (
        <button className="header-create-btn" onClick={handleCreate} title="Create New Entry">
          <i className="fas fa-plus"></i>
        </button>
      )}

      {showDelete && hasSelectedRows && (
        <button onClick={handleDeleteSelected} className="header-delete-btn" title="Delete Selected">
          <i className="fas fa-trash"></i>
        </button>
      )}
    </div>
  </div>
</div>


);

export default ProductListHeader;
